
// import _ from 'lodash'
import Search from '@/components/SearchV3/index.vue';

export default {
  components: {
    Search: Search
  },

  props: {
    query: {
      type: Object,
      required: true
    },

    handleSearch: {
      type: Function,
      required: true
    },

    handleResetSearch: {
      type: Function,
      required: true
    },

    keyField: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    formItems: {
      type: Array,
      default: null
    },

    columnConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    // 通过父级传入search_field配置项
    return {};
  },


  computed: {
    // 根据 formItems 过滤表单项
    formItemList: function formItemList() {
      var _this = this;

      return [{
        prop: 'name',
        type: 'input',
        params: function params(_ref) {
          var formValue = _ref.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            placeholder: formValue.search_field ? '按' + _this.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入版本名称关键字'
          };
        }
      }, {
        prop: 'description',
        type: 'input',
        params: function params(_ref2) {
          var formValue = _ref2.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            placeholder: formValue.search_field ? '按' + _this.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入版本描述关键字'
          };
        }
      }, {
        type: 'date-picker',
        subtype: 'daterange',
        prop: 'time',
        params: {
          disabled: false,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        }
      }];
    },
    innerFormList: function innerFormList() {
      var _this2 = this;

      return this.formItemList.filter(function (item) {
        if (_this2.formItems && _this2.formItems.indexOf(item.prop) === -1) {
          return false;
        }
        return true;
      });
    }
  },

  methods: {},

  mounted: function mounted() {}
};